import { AboutMe } from './AboutMe/AboutMe';
import { App } from './App/App';
import { Home } from './Home/Home';
import { Header } from './Header/Header';
import { Projects } from './Projects/Projects';
import { Footer } from './Footer/Footer';
import { Skills } from './Skills/Skills';
import { NotFound } from './NotFound/NotFound';

const pages = { AboutMe, App, Home, Header, Projects, Footer, Skills, NotFound };

export default pages;
